import React from "react";
import styled from "styled-components";
import { H2 } from "storybook-components/Typography";

const Title = styled(H2)`
  color: ${({ theme }) => theme.colors.green5};
  margin: 16px;
  ${props => props.theme.media.tabletUp`
    margin: 8px 0 32px 0;
  `};
`;

export default ({ align, headerText }) => (
  <Title align={align}>{headerText}</Title>
);
